import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.CATEGORY_DELETE_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.CATEGORY_DELETE_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const categoryDelete = (categoryId) => {
  return async (dispatch) => {
    dispatch({ type: CONST.CATEGORY_DELETE_REQUEST });

    axios.delete(`/categories/${categoryId}`).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
